import React from 'react';
import { useDispatch } from 'react-redux';
import { apiSlice } from '../../store/api/apiSlice';

const REFERENCE_TAGS = [
  'Contractor',
  'Warehouse',
  'Client',
  'Expeditor',
  'Shipper',
  'Consignee',
  'RailwayStation',
  'Airport',
  'Driver',
  'Vehicle',
  'Carrier',
] as const;

const POLL_INTERVAL_MS = 30000;

const ReferencesAutoRefresh: React.FC = () => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    const intervalId = window.setInterval(() => {
      // Skip background tabs to reduce unnecessary traffic.
      if (document.visibilityState !== 'visible') return;
      dispatch(apiSlice.util.invalidateTags([...REFERENCE_TAGS]));
    }, POLL_INTERVAL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [dispatch]);

  return null;
};

export default ReferencesAutoRefresh;
